import Vue from "vue";
import App from "./App.vue";
import router from "./router/index.js";
import store from "./store";
import { i18n } from "./translations/i18nSetup";
import "@/scss/app.scss";
import "@/scss/colors.scss";
import "@/scss/rtl.scss";
import "@/css/common.css";
import firebase from "firebase";
import VueAnalytics from "vue-analytics";
import commonApi from "./api/commonApi";
import localStorageUtil from "@/utils/localStorageUtil";

// material icon library css
import 'material-icons/iconfont/material-icons.css';

// Validate
import VeeValidate from "vee-validate";
import "@/filters/filters";
import VueScrollTo from "vue-scrollto";
import format from "vue-format";
import VueMathjax from "vue-mathjax";
//import Moment from 'moment'
import Moment from "moment-timezone";
import VueLodash from "vue-lodash";
import CircularCountDownTimer from "vue-circular-count-down-timer";
import RangeSlider from "vue-range-slider";
import Paginate from "vuejs-paginate";
// Plugins Define
import AlertModal from "./plugins/alertModal.js";
import SnackBar from "./plugins/snackBar.js";
import CommonPlugin from "./plugins/common.js";
import LoadingPlugin from "./plugins/loading.js";
import {storageConstants} from "@/utils/enum/StorageConstants";

Vue.use(VeeValidate);
VeeValidate.Validator.extend("verify_password", {
  validate: value => {
    var strongRegex = new RegExp("^.*(?=.{8,20})(?=.*[0-9])(?=.*[a-zA-Z]).*$");
    return strongRegex.test(value);
  }
});

Vue.use(VueScrollTo, {
  container: "body",
  duration: 500,
  easing: "ease",
  offset: 0,
  force: true,
  cancelable: true,
  onStart: false,
  onDone: false,
  onCancel: false,
  x: false,
  y: true
});

Vue.use(format);

Vue.use(VueMathjax);

Moment.locale(
  localStorage.getItem("languageInfo")
    ? JSON.parse(localStorage.getItem("languageInfo")).code
    : "en"
);
Vue.prototype.$moment = Moment;

Vue.use(VueLodash, { name: "lodash" });

Vue.use(CircularCountDownTimer);

Vue.component("range-slider", RangeSlider);

Vue.component("paginate", Paginate);

Vue.use(AlertModal);
Vue.use(SnackBar);
Vue.use(CommonPlugin);
Vue.use(LoadingPlugin);

Vue.config.productionTip = false;
Vue.use(VueAnalytics, {
  id: "spcglobal-97d5f",
  router
});

/*
// Set Google analytics
import VueAnalytics from 'vue-analytics'
const isProd = true
Vue.use(VueAnalytics, {
    id: 'UA-140414059-1',
    router,
    autoTracking: {
        exception: true
    },
    debug: {
        enabled: !isProd,
        sendHitTask: isProd,
    }
})
*/

const getRuntimeConfig = async () => {
  const runtimeConfig = await fetch(
    "/config.json?" + Math.round(+new Date() / 1000)
  );
  return await runtimeConfig.json();
};
getRuntimeConfig().then(function(json) {
  var storage = localStorage;
  if (storage.getItem("VUE_APP_API_HOST") !== json.VUE_APP_API_HOST) {
    storage.removeItem("brandCode");
  }

  storage.setItem("VUE_APP_API_HOST", json.VUE_APP_API_HOST);
  storage.setItem("VUE_APP_PAYMENT_HOST", json.VUE_APP_PAYMENT_HOST);
  storage.setItem("NAVER_KEY", json.NAVER_KEY);
  storage.setItem("TELEGRAM_BOT", json.TELEGRAM_BOT);
  storage.setItem("TELEGRAM_URL", json.TELEGRAM_URL);
  storage.setItem(storageConstants.skillPathAuth, json[storageConstants.skillPathAuth])

  const browserTitle = storage.getItem("browserTitle");
  if (browserTitle) {
    document.title = browserTitle;
  }

  new Vue({
    router,
    created() {
      firebase.initializeApp(json.VUE_FIREBASE_INIT);
    },
    mounted() {
      document.querySelector("link[rel*='icon']").href = json.FAVICON_URL;

      window.addEventListener("contextmenu", function(e) {
        e.preventDefault();
      });

      const idpServiceUrl = json.IDP_SERVICE_URL;
      if (idpServiceUrl) {
        storage.setItem("IDP_SERVICE_URL", JSON.stringify(idpServiceUrl));
      }

      const idpSignOutUrl = json.IDP_SIGNOUT_URL;
      if (idpSignOutUrl) {
        storage.setItem("IDP_SIGNOUT_URL", idpSignOutUrl);
      }

      // this.getUTCTime();
    },

    methods: {
      async getUTCTime() {
        const getUTCTime = localStorageUtil.getUTCTime();
        if (getUTCTime || getUTCTime === 0) return;
        try {
            const result = await commonApi.getUTCTime(); 
            if (result && result.data) {
                const deviceDate = this.$moment().unix();
                localStorageUtil.setUTCTime(result.data.data - deviceDate);
            }
        } catch (error) {
            console.log("ERROR_GET_UTC_TIME : ", error);
        }
      }
    },
    store,
    i18n,
    render: h => h(App)
  }).$mount("#app");
});
